import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
const Chatbot = () => {
  const [messages, setMessages] = useState([
    { text: "Hi, I'm a chatbot. How can I help you?", isUser: false },
  ]);
  const [isLoading, setIsLoading] = useState(false);

  // Add the useRef hook
  const messagesContainerRef = useRef(null);

  useEffect(() => {
    localStorage.setItem("chatMessages", JSON.stringify(messages));
  }, [messages]);

  // Add a listener to save messages one last time before the component unmounts
  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.setItem("chatMessages", JSON.stringify(messages));
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [messages]);

  const sendUserMessageToAPI = async (userMessage) => {
    try {
      setIsLoading(true);
      const response = await fetch("https://robomatic-ai.p.rapidapi.com/api", {
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          "X-RapidAPI-Key":
            "35698e2ac8mshc23840ab07b4943p109e3fjsn49666b75f544",
          "X-RapidAPI-Host": "robomatic-ai.p.rapidapi.com",
        },
        body: new URLSearchParams({
          in: userMessage,
          op: "in",
          cbot: "1",
          SessionID: "RapidAPI1",
          cbid: "1",
          key: "RHMN5hnQ4wTYZBGCF3dfxzypt68rVP",
          ChatSource: "RapidAPI",
          duration: "1",
        }),
      });

      const data = await response.json();
      setIsLoading(false);
      return data.out;
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data from the API:", error);
      return "Error: Unable to fetch data from the API.";
    }
  };

  const handleUserMessage = async (e) => {
    if (e.key === "Enter" && e.target.value.trim() !== "") {
      const userMessage = e.target.value;
      const botResponse = await sendUserMessageToAPI(userMessage);

      // Replace <br /> with line breaks (\n) in the bot's response
      const formattedBotResponse = botResponse.replace(/<br \/>/g, "\n");

      setMessages([
        ...messages,
        { text: userMessage, isUser: true },
        { text: formattedBotResponse, isUser: false },
      ]);

      e.target.value = "";
    }
  };

  useEffect(() => {
    // Scroll to the bottom of the messages container whenever new messages are added
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }

    // Scroll to the bottom of the viewport
    window.scrollTo(0, document.body.scrollHeight);
  }, [messages]);

  return (
    <div className="d-flex" style={{ height: "100vh" }}>
      <div
        className="flex-grow-1 ml-2"
        style={{ height: "100%", overflowY: "auto" }}
      >
        <div className="container mt-5">
          <div className="card">
            <div
              className="card-body"
              style={{ height: "70%", overflowY: "auto" }}
              ref={messagesContainerRef}
            >
              {messages.map((message, index) => (
                <div
                  key={index}
                  className={`my-2 p-2 ${
                    message.isUser
                      ? "bg-primary text-white rounded-right"
                      : "bg-light text-dark rounded-left"
                  }`}
                >
                  {message.text.split("\n").map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </div>
              ))}
              {isLoading && (
                <div className="text-center">
                  <div className="spinner-grow text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}
            </div>
            <div className="card-footer">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Type your message..."
                  onKeyDown={handleUserMessage}
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={handleUserMessage}
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
            <footer className="text-center mt-3">
              <p>
                © {new Date().getFullYear()} All rights reserved. Designed and
                Developed with{" "}
                <span role="img" aria-label="heart emoji">
                  ❤️
                </span>{" "}
                by Usman Tanveer
              </p>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chatbot;
